/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CampaignCreatedBy,
    CampaignCreatedByFromJSON,
    CampaignCreatedByFromJSONTyped,
    CampaignCreatedByToJSON,
} from './CampaignCreatedBy';
import {
    Contact,
    ContactFromJSON,
    ContactFromJSONTyped,
    ContactToJSON,
} from './Contact';
import {
    MessageBounceSubtype,
    MessageBounceSubtypeFromJSON,
    MessageBounceSubtypeFromJSONTyped,
    MessageBounceSubtypeToJSON,
} from './MessageBounceSubtype';
import {
    MessageBounceType,
    MessageBounceTypeFromJSON,
    MessageBounceTypeFromJSONTyped,
    MessageBounceTypeToJSON,
} from './MessageBounceType';
import {
    MessageMedium,
    MessageMediumFromJSON,
    MessageMediumFromJSONTyped,
    MessageMediumToJSON,
} from './MessageMedium';
import {
    MessageObjectType,
    MessageObjectTypeFromJSON,
    MessageObjectTypeFromJSONTyped,
    MessageObjectTypeToJSON,
} from './MessageObjectType';
import {
    MessageReceipt,
    MessageReceiptFromJSON,
    MessageReceiptFromJSONTyped,
    MessageReceiptToJSON,
} from './MessageReceipt';
import {
    MessageState,
    MessageStateFromJSON,
    MessageStateFromJSONTyped,
    MessageStateToJSON,
} from './MessageState';
import {
    MessageType,
    MessageTypeFromJSON,
    MessageTypeFromJSONTyped,
    MessageTypeToJSON,
} from './MessageType';

/**
 * 
 * @export
 * @interface Message
 */
export interface Message {
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    id: string;
    /**
     * 
     * @type {MessageObjectType}
     * @memberof Message
     */
    object: MessageObjectType;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    program_id: string;
    /**
     * 
     * @type {MessageType}
     * @memberof Message
     */
    type: MessageType;
    /**
     * 
     * @type {MessageMedium}
     * @memberof Message
     */
    medium: MessageMedium;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    sender_name: string;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    body: string;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    reference_id?: string;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    campaign_id?: string;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    conversation_id: string;
    /**
     * 
     * @type {MessageState}
     * @memberof Message
     */
    state: MessageState;
    /**
     * 
     * @type {Contact}
     * @memberof Message
     */
    contact: Contact;
    /**
     * 
     * @type {Array<MessageReceipt>}
     * @memberof Message
     */
    receipts: Array<MessageReceipt>;
    /**
     * The message has received confirmation of delivery.
     * @type {boolean}
     * @memberof Message
     */
    is_delivered: boolean;
    /**
     * The current user has receipt of viewing the message.
     * @type {boolean}
     * @memberof Message
     */
    is_read: boolean;
    /**
     * The message has been opened by the recipient.
     * @type {boolean}
     * @memberof Message
     */
    is_open: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Message
     */
    has_been_clicked: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Message
     */
    is_product_added: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Message
     */
    is_purchased: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Message
     */
    is_unsubscribed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Message
     */
    is_complaint: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Message
     */
    has_attachments: boolean;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    timezone: string;
    /**
     * 
     * @type {any}
     * @memberof Message
     */
    placeholder_data?: any;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    fail_reason?: string;
    /**
     * 
     * @type {number}
     * @memberof Message
     */
    send_attempts: number;
    /**
     * 
     * @type {MessageBounceType}
     * @memberof Message
     */
    bounce_type?: MessageBounceType;
    /**
     * 
     * @type {MessageBounceSubtype}
     * @memberof Message
     */
    bounce_subtype?: MessageBounceSubtype;
    /**
     * 
     * @type {Date}
     * @memberof Message
     */
    created: Date;
    /**
     * 
     * @type {CampaignCreatedBy}
     * @memberof Message
     */
    created_by?: CampaignCreatedBy;
    /**
     * 
     * @type {Date}
     * @memberof Message
     */
    updated?: Date;
    /**
     * 
     * @type {CampaignCreatedBy}
     * @memberof Message
     */
    updated_by?: CampaignCreatedBy;
    /**
     * 
     * @type {Date}
     * @memberof Message
     */
    sent?: Date;
    /**
     * 
     * @type {CampaignCreatedBy}
     * @memberof Message
     */
    sent_by?: CampaignCreatedBy;
    /**
     * 
     * @type {Date}
     * @memberof Message
     */
    delivered?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Message
     */
    opened?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Message
     */
    clicked?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Message
     */
    product_added?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Message
     */
    purchased?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Message
     */
    unsubscribed?: Date;
}

export function MessageFromJSON(json: any): Message {
    return MessageFromJSONTyped(json, false);
}

export function MessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): Message {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'object': MessageObjectTypeFromJSON(json['object']),
        'program_id': json['program_id'],
        'type': MessageTypeFromJSON(json['type']),
        'medium': MessageMediumFromJSON(json['medium']),
        'sender_name': json['sender_name'],
        'subject': json['subject'],
        'body': json['body'],
        'reference_id': !exists(json, 'reference_id') ? undefined : json['reference_id'],
        'campaign_id': !exists(json, 'campaign_id') ? undefined : json['campaign_id'],
        'conversation_id': json['conversation_id'],
        'state': MessageStateFromJSON(json['state']),
        'contact': ContactFromJSON(json['contact']),
        'receipts': ((json['receipts'] as Array<any>).map(MessageReceiptFromJSON)),
        'is_delivered': json['is_delivered'],
        'is_read': json['is_read'],
        'is_open': json['is_open'],
        'has_been_clicked': json['has_been_clicked'],
        'is_product_added': json['is_product_added'],
        'is_purchased': json['is_purchased'],
        'is_unsubscribed': json['is_unsubscribed'],
        'is_complaint': json['is_complaint'],
        'has_attachments': json['has_attachments'],
        'timezone': json['timezone'],
        'placeholder_data': !exists(json, 'placeholder_data') ? undefined : json['placeholder_data'],
        'fail_reason': !exists(json, 'fail_reason') ? undefined : json['fail_reason'],
        'send_attempts': json['send_attempts'],
        'bounce_type': !exists(json, 'bounce_type') ? undefined : MessageBounceTypeFromJSON(json['bounce_type']),
        'bounce_subtype': !exists(json, 'bounce_subtype') ? undefined : MessageBounceSubtypeFromJSON(json['bounce_subtype']),
        'created': (new Date(json['created'])),
        'created_by': !exists(json, 'created_by') ? undefined : CampaignCreatedByFromJSON(json['created_by']),
        'updated': !exists(json, 'updated') ? undefined : (new Date(json['updated'])),
        'updated_by': !exists(json, 'updated_by') ? undefined : CampaignCreatedByFromJSON(json['updated_by']),
        'sent': !exists(json, 'sent') ? undefined : (new Date(json['sent'])),
        'sent_by': !exists(json, 'sent_by') ? undefined : CampaignCreatedByFromJSON(json['sent_by']),
        'delivered': !exists(json, 'delivered') ? undefined : (new Date(json['delivered'])),
        'opened': !exists(json, 'opened') ? undefined : (new Date(json['opened'])),
        'clicked': !exists(json, 'clicked') ? undefined : (new Date(json['clicked'])),
        'product_added': !exists(json, 'product_added') ? undefined : (new Date(json['product_added'])),
        'purchased': !exists(json, 'purchased') ? undefined : (new Date(json['purchased'])),
        'unsubscribed': !exists(json, 'unsubscribed') ? undefined : (new Date(json['unsubscribed'])),
    };
}

export function MessageToJSON(value?: Message | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'object': MessageObjectTypeToJSON(value.object),
        'program_id': value.program_id,
        'type': MessageTypeToJSON(value.type),
        'medium': MessageMediumToJSON(value.medium),
        'sender_name': value.sender_name,
        'subject': value.subject,
        'body': value.body,
        'reference_id': value.reference_id,
        'campaign_id': value.campaign_id,
        'conversation_id': value.conversation_id,
        'state': MessageStateToJSON(value.state),
        'contact': ContactToJSON(value.contact),
        'receipts': ((value.receipts as Array<any>).map(MessageReceiptToJSON)),
        'is_delivered': value.is_delivered,
        'is_read': value.is_read,
        'is_open': value.is_open,
        'has_been_clicked': value.has_been_clicked,
        'is_product_added': value.is_product_added,
        'is_purchased': value.is_purchased,
        'is_unsubscribed': value.is_unsubscribed,
        'is_complaint': value.is_complaint,
        'has_attachments': value.has_attachments,
        'timezone': value.timezone,
        'placeholder_data': value.placeholder_data,
        'fail_reason': value.fail_reason,
        'send_attempts': value.send_attempts,
        'bounce_type': MessageBounceTypeToJSON(value.bounce_type),
        'bounce_subtype': MessageBounceSubtypeToJSON(value.bounce_subtype),
        'created': (value.created.toISOString()),
        'created_by': CampaignCreatedByToJSON(value.created_by),
        'updated': value.updated === undefined ? undefined : (value.updated.toISOString()),
        'updated_by': CampaignCreatedByToJSON(value.updated_by),
        'sent': value.sent === undefined ? undefined : (value.sent.toISOString()),
        'sent_by': CampaignCreatedByToJSON(value.sent_by),
        'delivered': value.delivered === undefined ? undefined : (value.delivered.toISOString()),
        'opened': value.opened === undefined ? undefined : (value.opened.toISOString()),
        'clicked': value.clicked === undefined ? undefined : (value.clicked.toISOString()),
        'product_added': value.product_added === undefined ? undefined : (value.product_added.toISOString()),
        'purchased': value.purchased === undefined ? undefined : (value.purchased.toISOString()),
        'unsubscribed': value.unsubscribed === undefined ? undefined : (value.unsubscribed.toISOString()),
    };
}

